import React, { useCallback } from 'react';
import { StyledCheckedItem } from 'src/features/common/explore/components/explore-nft-filter-items/styles';
import { Checkbox } from 'src/ui/common/atoms/checkbox';
import { Typography } from 'src/ui/common/atoms/typography';
import { decodeHTMLEntities } from 'src/utils/html.utils';

interface IProps {
    id: string | number;
    label: string;
    checked?: boolean;
    onChange: (id: string | number, state: boolean) => void;
    header?: string;
}

export const FilterCheckboxItem: React.FC<IProps> = ({ id, header, label, checked, onChange }) => {
    const handleClick = useCallback(() => {
        onChange(id, !checked);
    }, [checked, id, onChange]);

    if (header) {
        return (
            <> 
            <div style={{ margin: '20px 0 10px 0', fontSize: '16px' }}>{header}</div>
                <StyledCheckedItem checked={!!checked} alignItems="center" justifyContent="space-between" onClick={handleClick}>
                    <Typography size="sm" overflowLines={1} altTitle={decodeHTMLEntities(label)}>
                        {decodeHTMLEntities(label)}
                    </Typography>
                    <Checkbox checked={checked} disabled />
                </StyledCheckedItem>
            </>

        );
    } 
        return (<StyledCheckedItem checked={!!checked} alignItems="center" justifyContent="space-between" onClick={handleClick}>
            <Typography size="sm" overflowLines={1} altTitle={decodeHTMLEntities(label)}>
                {decodeHTMLEntities(label)}
            </Typography>
            <Checkbox checked={checked} disabled />
                </StyledCheckedItem>
        );
    

};
